import { useCallback, useState } from 'react';

/**
 * Hook to manage the third-party connector setup modal state.
 *
 * Returns `openSetupModal` to set the active connector key,
 * `activeConnectorKey` to determine which connector modal to show,
 * and `closeModal` to dismiss it. The actual modal rendering is handled
 * by the surface component (e.g. ConnectorPromoSidebar) using SetupConnectorModal.
 */
export function useSetupConnector() {
	const [activeConnectorKey, setActiveConnectorKey] = useState<string | null>(null);

	const openSetupModal = useCallback((connectorKey: string) => {
		setActiveConnectorKey(connectorKey);
	}, []);

	const closeModal = useCallback(() => {
		setActiveConnectorKey(null);
	}, []);

	return { openSetupModal, activeConnectorKey, closeModal };
}
